import {
  Box,
  Checkbox,
  Grid,
  IconButton,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import {
  Sub_addterms,
  Sub_contractreview,
  Sub_duediligence,
  Sub_finance,
} from 'component/Termsicons';
import React, { useEffect, useState } from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircleOutline';
import CheckCircleFilledIcon from '@mui/icons-material/CheckCircle';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const EditIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.5 18.4984H6L17.8125 6.68589C18.4092 6.08915 18.7445 5.2798 18.7445 4.43589C18.7445 3.59197 18.4092 2.78262 17.8125 2.18589C17.2158 1.58915 16.4064 1.25391 15.5625 1.25391C14.7186 1.25391 13.9092 1.58915 13.3125 2.18589L1.5 13.9984V18.4984Z"
        stroke="#6C2AD2"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

const ConditionalTerms = (props) => {
  const {
    makeOfferListArray,
    hideOthers,
    setSelectedConditionCodes,
    setSettlementDays,
    setDepositAmount,
    setStateIndex,
    handleClickOpen,
    subtoAddSelected,
    selectedItems,
    setSelectedItems,
    isFocusModeTerms,
    setDepAmount,
    resetTerms,
    setResetTerms,
    selectedConditionCodes,
    saveTerms,
    setSettleDays,
    identicalsuggestion,
    setSubtoAddSelected,
    setAdditionalComment,
    sharedpage,
  } = props;

  const theme = useTheme();
  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));
  const matches650 = useMediaQuery(theme.breakpoints.down(650));
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const [checked, setChecked] = useState(false);

  const [initialValues, setInitialValues] = useState({});
  const [editValues, setEditValues] = useState({});
  const [editingField, setEditingField] = useState({});
  const [isEditingIndex, setIsEditingIndex] = useState(false);

  const handleChange = (index, type, value) => {
    // Update local state for editing
    setEditValues((prev) => ({
      ...prev,
      [index]: {
        ...prev[index],
        [type]: value,
      },
    }));

    // Update parent state with just the value
    if (type === 'deposit') {
      setDepAmount(value); // ✅ just the string value
    }

    if (type === 'settlement') {
      setSettleDays(value); // ✅ just the string value
    }
  };

  const [initialTermsListArray, setInitialTermsListArray] = useState([]);

  // Reset array when resetTerms becomes true
  useEffect(() => {
    if (!makeOfferListArray?.getExistCondition || resetTerms) {
      setSelectedItems([]);
      setSelectedConditionCodes([]);

      setSubtoAddSelected(false);
      setAdditionalComment('');

      setInitialTermsListArray(
        Array.isArray(makeOfferListArray?.conditionlist)
          ? [...makeOfferListArray.conditionlist]
          : []
      );
      setResetTerms(false);
    }
  }, [resetTerms, makeOfferListArray]);

  useEffect(() => {
    if (!resetTerms && makeOfferListArray?.getExistCondition) {
      const newArray = Array.isArray(makeOfferListArray?.getExistCondition)
        ? [...makeOfferListArray.getExistCondition]
        : [];

      const preselectedIndexes = [];
      const preselectedCodes = [];

      let existingAddComment = '';

      newArray.forEach((item, index) => {
        if (item?.isSelected == 1) {
          preselectedIndexes.push(index);
          preselectedCodes.push(item?.conditionSubjectCode);

          if (item?.conditionSubjectCode == 'SubtoAdd001') {
            setSubtoAddSelected(true);
            existingAddComment = item?.conditionSubjectFile || '';
            setAdditionalComment(existingAddComment);
          }
        }
      });

      setInitialTermsListArray(newArray);
      setSelectedItems(preselectedIndexes);
      setSelectedConditionCodes(preselectedCodes);
    }
  }, [makeOfferListArray, identicalsuggestion]);

  useEffect(() => {
    if (initialTermsListArray?.length) {
      const original = {};
      let initialDeposit = '';
      let initialSettlement = '';

      initialTermsListArray.forEach((item, index) => {
        const deposit =
          item?.conditionSubjectCode === 'SubtoDep001'
            ? item.conditionSubjectFile || ''
            : '';
        const settlement =
          item?.conditionSubjectCode === 'SubtoSettle001'
            ? item.conditionSubjectFile || ''
            : '';

        original[index] = { deposit, settlement };

        if (deposit) initialDeposit = deposit;
        if (settlement) initialSettlement = settlement;
      });

      setInitialValues(original);
      setEditValues(original);

      setDepAmount(initialDeposit);
      setSettleDays(initialSettlement);
    }
  }, [initialTermsListArray]);

  return (
    <Grid
      container
      xs={12}
      md={12}
      lg={12}
      xl={12}
      spacing={isFocusModeTerms && 2}
      sx={{
        display: !hideOthers ? 'flex' : 'none',
        justifyContent: !matchesmd ? 'start' : 'center',
        gap: '10px',
        marginTop: '5%',
        flexWrap: 'wrap',
      }}
    >
      {initialTermsListArray?.length > 0 &&
        initialTermsListArray?.map((item, index) => {
          const isSelected = selectedItems.includes(index);
          const isSubtoCon001 = item?.conditionSubjectCode == 'SubtoCon001';
          const isSubtoDue001 = item?.conditionSubjectCode == 'SubtoDue001';
          const isSubtoFin001 = item?.conditionSubjectCode == 'SubtoFin001';
          const isSubtoDep001 = item?.conditionSubjectCode == 'SubtoDep001';
          const isSubtoSettle001 =
            item?.conditionSubjectCode == 'SubtoSettle001';
          const isSubtoAdd001 = item?.conditionSubjectCode == 'SubtoAdd001';
          const type = isSubtoDep001 ? 'deposit' : 'settlement';

          // Get settlement value for singular/plural
          const settlementValue = editValues[index]?.settlement;

          return (
            <Grid
              item
              xs={5.5}
              md={3.8}
              lg={isFocusModeTerms ? 3.8 : 2.8}
              xl={isFocusModeTerms ? 3.84 : 1.9}
              onClick={() => {
                if (isSubtoSettle001) {
                  setSettlementDays(item?.conditionSubjectFile);
                }
                if (isSubtoDep001) {
                  setDepositAmount(item?.conditionSubjectFile);
                }
                if (isSubtoAdd001) {
                  handleClickOpen();
                } else {
                  if (isSelected) {
                    setSelectedConditionCodes((prevSelected) =>
                      prevSelected.filter(
                        (code) => code !== item?.conditionSubjectCode
                      )
                    );
                  } else {
                    setSelectedConditionCodes((prevSelected) => [
                      ...prevSelected,
                      item?.conditionSubjectCode,
                    ]);
                  }
                  setStateIndex(index);

                  if (isSelected) {
                    setSelectedItems((prevSelected) =>
                      prevSelected.filter((i) => i !== index)
                    );
                  } else {
                    setSelectedItems((prevSelected) => [
                      ...prevSelected,
                      index,
                    ]);
                  }

                  if (item.conditionSubjectCode == 'SubtoAdd001') {
                    handleClickOpen();
                  }
                }
              }}
              sx={{
                cursor: 'pointer',
                width: matches650 ? '250px' : '200px',
              }}
              key={index}
            >
              <Grid
                item
                sx={{
                  background: isSubtoAdd001
                    ? subtoAddSelected
                      ? 'linear-gradient(0deg, rgba(108, 42, 210, 0.1), rgba(108, 42, 210, 0.1))'
                      : 'white'
                    : isSelected
                    ? 'linear-gradient(0deg, rgba(108, 42, 210, 0.1), rgba(108, 42, 210, 0.1))'
                    : 'white',
                  borderRadius: '8px',
                  border:
                    isSelected || (isSubtoAdd001 && subtoAddSelected)
                      ? '0.5px solid #6C2AD2'
                      : '0.5px solid #DFDFDF',
                  display: 'flex',
                  justifyContent: 'center',
                  flexDirection: 'column',
                  gap: matchessm && '10px',
                  minWidth: !isFocusModeTerms && '150px',
                  height: isFocusModeTerms ? '117px' : '140px',
                  width: isFocusModeTerms && '149px',
                  alignItems: 'center',
                  position: 'relative',
                }}
              >
                {(isSubtoDep001 || isSubtoSettle001) && (
                  <Box
                    sx={{
                      position: 'absolute',
                      right: 7,
                      top: 4,
                    }}
                  >
                    <IconButton
                      disabled={sharedpage}
                      onClick={(event) => {
                        event.stopPropagation();
                        if (isSubtoSettle001) {
                          setSettlementDays(item?.conditionSubjectFile);
                        }
                        if (isSubtoDep001) {
                          setDepositAmount(item?.conditionSubjectFile);
                        }

                        const type = isSubtoDep001 ? 'deposit' : 'settlement';
                        setEditingField((prev) => ({
                          ...prev,
                          [index]: type,
                        }));
                        if (!isSelected) {
                          setSelectedConditionCodes((prevSelected) => [
                            ...prevSelected,
                            item?.conditionSubjectCode,
                          ]);
                          setSelectedItems((prevSelected) => [
                            ...prevSelected,
                            index,
                          ]);
                          setStateIndex(index);
                        }
                      }}
                    >
                      <EditIcon />
                    </IconButton>
                  </Box>
                )}
                <Typography
                  sx={{
                    height: !matchessm ? '80px' : null,
                    padding: matchessm ? '5px' : '15px',
                  }}
                >
                  {isSubtoSettle001 || isSubtoDep001 ? (
                    editingField[index] === type ? (
                      <TextField
                        variant="standard"
                        value={editValues[index]?.[type] || ''}
                        autoFocus
                        onChange={(e) => {
                          const rawValue = e.target.value;

                          // Only allow digits
                          if (!/^\d*$/.test(rawValue)) return;

                          const numericValue = Number(rawValue);

                          // Validate based on field type
                          if (type === 'settlement') {
                            if (numericValue >= 0 && numericValue <= 999) {
                              handleChange(index, type, rawValue);
                            }
                          }

                          if (type === 'deposit') {
                            if (numericValue >= 0 && numericValue <= 100) {
                              handleChange(index, type, rawValue);
                            }
                          }
                        }}
                        onBlur={() => {
                          const currentValue = editValues[index]?.[type];
                          const initialValue =
                            initialValues[index]?.[type] || '';

                          if (currentValue == '' || currentValue == undefined) {
                            setEditValues((prev) => ({
                              ...prev,
                              [index]: {
                                ...prev[index],
                                [type]: initialValue,
                              },
                            }));

                            if (type == 'deposit') setDepAmount(initialValue);
                            if (type == 'settlement')
                              setSettleDays(initialValue);
                          }

                          setEditingField((prev) => ({
                            ...prev,
                            [index]: null,
                          }));
                        }}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            const currentValue = editValues[index]?.[type];
                            const initialValue =
                              initialValues[index]?.[type] || '';

                            if (
                              currentValue == '' ||
                              currentValue == undefined
                            ) {
                              setEditValues((prev) => ({
                                ...prev,
                                [index]: {
                                  ...prev[index],
                                  [type]: initialValue,
                                },
                              }));

                              if (type === 'deposit')
                                setDepAmount(initialValue);
                              if (type === 'settlement')
                                setSettleDays(initialValue);
                            }
                            setEditingField((prev) => ({
                              ...prev,
                              [index]: null,
                            }));
                          }
                        }}
                        inputProps={{
                          style: {
                            textAlign: 'center',
                            fontFamily: 'Poppins',
                            fontSize: '32px',
                            fontWeight: 500,
                            color: isSelected ? '#6C2AD2' : '#666666',
                          },
                          maxLength: type === 'settlement' ? 3 : 3, // limit to 3 digits
                        }}
                        InputProps={{
                          disableUnderline: true,
                          sx: {
                            textAlign: 'center',
                            fontFamily: 'Poppins',
                            fontSize: '32px',
                            fontWeight: 500,
                            color: isSelected ? '#6C2AD2' : '#666666',
                          },
                        }}
                        fullWidth
                      />
                    ) : (
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                      >
                        <Typography
                          sx={{
                            fontFamily: 'Poppins !important',
                            fontStyle: 'normal !important',
                            fontWeight: '500 !important',
                            fontSize: '32px',
                            color: isSelected ? '#6C2AD2' : '#666666',
                            textAlign: 'center',
                          }}
                        >
                          {editValues[index]?.[type]}
                          {isSubtoDep001 && '%'}
                        </Typography>
                      </Box>
                    )
                  ) : isSubtoCon001 ? (
                    <Sub_contractreview
                      color={isSelected ? '#6C2AD2' : '#666666'}
                    />
                  ) : isSubtoDue001 ? (
                    <Sub_duediligence
                      color={isSelected ? '#6C2AD2' : '#666666'}
                    />
                  ) : isSubtoFin001 ? (
                    <Sub_finance color={isSelected ? '#6C2AD2' : '#666666'} />
                  ) : isSubtoAdd001 ? (
                    <Sub_addterms
                      color={isSelected ? '#6C2AD2' : '#666666'}
                      matchessm={matchessm}
                    />
                  ) : null}
                </Typography>

                <Typography
                  sx={{
                    fontFamily: 'Poppins !important',
                    fontStyle: 'normal !important',
                    fontWeight: '300 !important',
                    fontSize: isFocusModeTerms ? '12px' : '14px',
                    width: '100%',
                    color: isSubtoAdd001
                      ? subtoAddSelected
                        ? '#6C2AD2'
                        : '#666666'
                      : isSelected
                      ? '#6C2AD2'
                      : '#666666',
                    textAlign: 'center',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {isSubtoCon001 ? (
                    <>
                      Subject to <br /> Contract Review
                    </>
                  ) : isSubtoDue001 ? (
                    <>
                      Subject to <br />
                      Due Diligence{' '}
                    </>
                  ) : isSubtoFin001 ? (
                    <>
                      Subject to <br /> Finance{' '}
                    </>
                  ) : isSubtoDep001 ? (
                    <>
                      Deposit <br /> Amount{' '}
                    </>
                  ) : isSubtoSettle001 ? (
                    <>
                      Settlement <br />{' '}
                      {settlementValue
                        ? `${Number(settlementValue) === 1 ? 'Day' : 'Days'}`
                        : 'Days'}
                    </>
                  ) : isSubtoAdd001 ? (
                    <>
                      Add <br /> Additional Condition{' '}
                    </>
                  ) : null}
                </Typography>
              </Grid>
            </Grid>
          );
        })}
    </Grid>
  );
};

export default ConditionalTerms;
